export default [
    { id: 1, name: "Project", selected: true },
    { id: 2, name: "People", selected: false },
    { id: 3, name: "Mix", selected: false },
    { id: 4, name: "Mix", selected: false },
];
